import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { timeout } from 'rxjs/operators';
import { Area } from '../../core/constants/area';
import { Observable } from 'rxjs/Observable';
import { NonRecourseBrokerResponse } from '../../portal/internal-scoring/models/responses/NonRecourseBrokerResponse';
import { UpdateCreditInfoDetailModel } from './UpdateCreditInfoDetailModel';
@Injectable()
export class AnsoniaService {

  constructor(public httpClient: HttpClient) { }

  search(los): any {
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/Search?mcNumber=${los.MCNumber}&name=${los.Name}&address1=${los.Address1}&city=${los.City}&state=${los.State}&country=${los.Country}`;
    return this.httpClient.get(url, httpOptions).pipe(timeout(30000));
  }

  getQuickCreditFromLOS(entityID: number, isOverride: boolean): any {
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/GetQuickCreditFromLOS?entityID=${entityID}&isOverride=${isOverride}`;
    return this.httpClient.get(url, httpOptions).pipe(timeout(30000));
  }

  getQuickCredit(los): any {
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/GetQuickCredit?mcNumber=${los.mcNumber}&address1=${los.address1 }&city=${los.city}&state=${los.cstate}&country=${los.country }`;
    return this.httpClient.get(url, httpOptions).pipe(timeout(30000));
  }

  getUserCreditChecksCount(userId: number): any {
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/GetUserCreditChecksCount?userId=${userId}`;
    return this.httpClient.get(url, httpOptions).pipe(timeout(30000));
  }

  patchApprovalOverrideActive(entityId: number, isOverride: boolean){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/OverrideApproval`;
    return this.httpClient.patch<any[]>(url, {id: entityId, boolean: isOverride});
  }

  getTopVendors(grading: string, sourceSystemId?: number): any {
    const httpOptions = {};
    let url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/GetTopVendors?grading=${grading}`;
    if (sourceSystemId != null) {
      url += `&sourceSystemId=${sourceSystemId}`;
    }
    return this.httpClient.get(url, httpOptions).pipe(timeout(300000));
  }

  getNonRecourseBrokers(sourceSystemId?: number): Observable<NonRecourseBrokerResponse[]> {
    let url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/GetNonRecourseBrokers`;
    if (sourceSystemId != null) {
      url += `?sourceSystemId=${sourceSystemId}`;
    }
    return this.httpClient.get<NonRecourseBrokerResponse[]>(url).pipe(timeout(300000));
  }

  getCreditAlertList(){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/CreditAlert/List`;
    return this.httpClient.get<any[]>(url);
  }
  getCreditInfoDetail(entityId: number){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/CreditInfo/Detail?entityId=${entityId}`;
    return this.httpClient.get<any[]>(url);
  }
  updateCreditInfoDetail(model: UpdateCreditInfoDetailModel){
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/Ansonia/CreditInfo/Detail`;
    return this.httpClient.put<any[]>(url, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ansonia/ansonia.service.ts